<template>
  <div class="panel panel-default payment-admin-area">
    <div class="panel-heading">
      <h3>Destinations</h3>
    </div>
    <div class="panel-body">
      <pre class="messages">{{ messages }}</pre>
    </div>
    <div class="panel-heading">
      <h3>Count</h3>
    </div>
    <div class="panel-body">
      <pre class="messages">{{ count }}</pre>
    </div>
    <ul v-if="errors && errors.length">
      <li v-for="error of errors" :key="error.message">{{error.message}}</li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: ['auth'],
  data () {
    return {
      messages: {},
      count: {},
      errors: []
    }
  },
  created () {
    const myHeaders = {
      Authorization: `Bearer ${this.auth.accessToken}`
    }
    var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_NOTIFICATION}/destinations/${this.auth.quberUser.userId}/addresses`

    rh.default.get(endpoint, true)
      .then(response => {
        this.messages = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })

    endpoint = `${process.env.VUE_APP_QUBER_SERVICE_NOTIFICATION}/owners/${this.auth.quberUser.userId}/history/count`
    rh.default.get(endpoint, true)
      .then(response => {
        this.count = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
  }
}
</script>

<style>
.profile-area img {
  max-width: 150px;
  margin-bottom: 20px
}

.panel-body h3 {
  margin-top: 0
}
</style>
